import { render } from "./energie_cinetique_potentielle.vue?vue&type=template&id=3e3de2f4&scoped=true&ts=true"
import script from "./energie_cinetique_potentielle.vue?vue&type=script&lang=ts"
export * from "./energie_cinetique_potentielle.vue?vue&type=script&lang=ts"

import "./energie_cinetique_potentielle.vue?vue&type=style&index=0&id=3e3de2f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e3de2f4"]])

export default __exports__